__webpack_require__.p = "https://bmidxbslovakiaplprod.netlify.app/";